import React from "react";
import "./OverlayLoader.css";

interface OverlayLoaderProps {
  message?: string;
}

export default function OverlayLoader({ message = "Enregistrement de la commande..." }: OverlayLoaderProps) {
  return (
    <div className="overlay-loader-backdrop">
      <div className="overlay-loader-content">
        <div className="spinner-border custom-spinner" role="status"></div>
        <span className="loader-charg">{message}</span>
      </div>
    </div>
  );
}
